import { select, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import { TopUpEWalletActionTypes } from './types';
import TopUpEWalletRequest from '../../models/eWallet/TopUpEWalletRequest';
import { topUpEWalletActions } from './actions';
import OrderService from '../../services/order.service';
import RedirectRequest from "../../models/order/RedirectRequest";
import CorvusUtility from '../../blocks/utils/corvus-utility';
import OrderResponse from '../../models/order/OrderResponse';
import Toast from '../../components/shared/Toast';
import { ApplicationState } from '..';
import { ResponseCode } from '../../models/order/ResponseCode';

export default function* eWalletSaga() {
    yield takeEvery(TopUpEWalletActionTypes.REQUEST, topUpEWalletRequest);
    yield takeEvery(TopUpEWalletActionTypes.SUCCESS, topUpEWalletSuccess);
    yield takeEvery(TopUpEWalletActionTypes.ERROR, topUpEWalletError);
}

function* topUpEWalletRequest(action: Action<TopUpEWalletRequest>) {
    const topUpEWalletRequest = action.payload;
    const isAuthenticated: boolean = yield select((state: ApplicationState) => state.auth.isAuthenticated);

    let redirectRequest: RedirectRequest;

    if (!isAuthenticated) {
        redirectRequest = { ePurseAmount: topUpEWalletRequest.amount, cardNumber: topUpEWalletRequest.cardNumber, buyerEmail: topUpEWalletRequest.email };
    }
    else {
        redirectRequest = { ePurseAmount: topUpEWalletRequest.amount };
    }

    yield sagaUtility(redirectRequest, OrderService.redirect, topUpEWalletActions.success, topUpEWalletActions.failure);
}

function* topUpEWalletSuccess(action: Action<any>) {
    const orderResponse = action.payload as OrderResponse;

    if (orderResponse?.ResponseCode === ResponseCode.Error) {
        Toast.notifyError(orderResponse.ResponseMessage);
    }
    else {
        CorvusUtility.redirectToPaymentForm(action.payload);
    }
}

function* topUpEWalletError(action: Action<OrderResponse>) {
    Toast.notifyError(action.payload.ResponseMessage);
}
